/* Paintly homepage: Custom paint by numbers, "Watch it paint" (round 6, cream). Section: sections/paintly-custom-photo.liquid
   The markup is rendered by Liquid; this only adds the demo. Nothing is downloaded for the demo until the section is
   about 600px from the screen. Then: example photo, numbered canvas, painted color by color from the real color map. */
(function () {
  if (window.PKCPS) return;
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.4-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5Z"/></svg>';
  var ICON_REPLAY = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.4-5.7"/><path d="M4 4v4.5h4.5"/></svg>';

  /* paints a numbered canvas color by color using the example's color map (labels png: pixel value = color number - 1) */
  function load(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  function Painter(cv, o) {
    this.K = o.colors; this.raf = 0; var self = this;
    this.ready = Promise.all([load(o.canvasImg), load(o.paintedImg), load(o.labelsImg)]).then(function (im) {
      var W = im[2].naturalWidth, H = im[2].naturalHeight;
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      function px(img) { ctx.clearRect(0, 0, W, H); ctx.drawImage(img, 0, 0, W, H); return ctx.getImageData(0, 0, W, H); }
      self.base = px(im[0]); self.paint = px(im[1]); var lab = px(im[2]).data;
      var counts = new Int32Array(self.K), n = W * H, i, k;
      for (i = 0; i < n; i++) counts[Math.min(lab[i * 4], self.K - 1)]++;
      self.idx = []; var fill = new Int32Array(self.K);
      for (i = 0; i < self.K; i++) self.idx.push(new Int32Array(counts[i]));
      for (i = 0; i < n; i++) { k = Math.min(lab[i * 4], self.K - 1); self.idx[k][fill[k]++] = i; }
      self.order = Array.from({ length: self.K }, function (_, j) { return j; }).sort(function (a, b) { return counts[b] - counts[a]; });
      self.out = ctx.createImageData(W, H); self.ctx = ctx;
      self.showNone();
    });
  }
  Painter.prototype.showNone = function () { this.out.data.set(this.base.data); this.ctx.putImageData(this.out, 0, 0); this.done = 0; };
  Painter.prototype.fillOne = function (k) { var a = this.idx[k], d = this.out.data, p = this.paint.data; for (var j = 0; j < a.length; j++) { var q = a[j] * 4; d[q] = p[q]; d[q + 1] = p[q + 1]; d[q + 2] = p[q + 2]; d[q + 3] = 255; } };
  Painter.prototype.play = function (ms, onStep, onEnd) {
    var self = this; this.stop(); this.showNone();
    var t0 = performance.now(), step = ms / this.K;
    function tick(t) {
      var want = Math.min(self.K, Math.floor((t - t0) / step) + 1), changed = false;
      while (self.done < want) { var k = self.order[self.done]; self.fillOne(k); self.done++; changed = true; if (onStep) onStep(k, self.done); }
      if (changed) self.ctx.putImageData(self.out, 0, 0);
      if (self.done < self.K) self.raf = requestAnimationFrame(tick); else { self.raf = 0; if (onEnd) onEnd(); }
    }
    this.raf = requestAnimationFrame(tick);
  };
  Painter.prototype.stop = function () { if (this.raf) cancelAnimationFrame(this.raf); this.raf = 0; };

  function fmt(n) { return Number(n).toLocaleString('en-US'); }

  function init(root) {
    if (root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var cfgEl = root.querySelector('.pkcps-cfg'); if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var A = function (k, K, kind) { return cfg.assets[k + (K ? '-' + K : '') + '-' + kind]; };
    var stg = root.querySelector('.wip-stage');
    var ph = stg.querySelector('.ph'), cv = stg.querySelector('.cv'), pc = stg.querySelector('.pc'), pt = stg.querySelector('.pt');
    var cap = stg.querySelector('.ct'), dph = root.querySelector('.dph');
    var plays = root.querySelectorAll('.js-play'), ns = root.querySelectorAll('.js-n'), ofs = root.querySelectorAll('.js-of');
    var steps = root.querySelectorAll('.js-step'), det = root.querySelectorAll('.cps-det button'), exbs = root.querySelectorAll('.wip-exb');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var key = 'grandma', K = 120, painter = null, timers = [], seen = false, running = false, built = false;
    function setPlay(icon) { plays.forEach(function (b) { b.innerHTML = icon; b.setAttribute('aria-label', icon === ICON_PLAY ? 'Watch it paint' : 'Paint it again'); }); }
    function clear() { timers.forEach(clearTimeout); timers = []; if (painter) painter.stop(); stg.classList.remove('mapping', 'running'); running = false; setPlay(ICON_PLAY); }
    function capFor(s) { return s === 'photo' ? 'Example photo' : s === 'canvas' ? fmt(cfg.regions[key][String(K)]) + ' numbered spaces' : 'Finished painting'; }
    function state(s) {
      stg.classList.toggle('s-canvas', s === 'canvas'); stg.classList.toggle('s-paint', s === 'paint');
      var order = ['photo', 'canvas', 'paint'], at = order.indexOf(s);
      steps.forEach(function (e) { var i = order.indexOf(e.getAttribute('data-s')); e.classList.toggle('on', i === at); e.classList.toggle('done', i < at); });
      cap.textContent = capFor(s);
      root.classList.toggle('at-photo', s === 'photo');
    }
    function count(n) { ns.forEach(function (e) { e.textContent = ('00' + n).slice(-3); }); }
    function build() {
      built = true;
      ofs.forEach(function (e) { e.textContent = '/ ' + K; });
      det.forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-k') === K)); });
      exbs.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-k') === key)); });
      var label = cfg.labels[key];
      ph.src = A(key, 0, 'photo'); ph.alt = 'Example photo: ' + label;
      cv.src = A(key, K, 'canvas'); cv.alt = 'The numbered canvas made from it';
      pt.src = A(key, K, 'paint'); pt.alt = 'The finished painting in ' + K + ' colors';
      if (dph) { dph.src = A(key, 0, 'photo'); dph.alt = 'Example photo: ' + label; }
      painter = new Painter(pc, { canvasImg: A(key, K, 'canvas'), paintedImg: A(key, K, 'paint'), labelsImg: A(key, K, 'labels'), colors: K });
      count(0);
      return painter.ready;
    }
    function paintNow() {
      stg.classList.add('running'); state('paint'); cap.textContent = 'You paint it, number by number';
      painter.play(reduce ? 300 : (K === 120 ? 6200 : 5000), function (k, done) { count(done); },
        function () { stg.classList.remove('running'); running = false; state('paint'); setPlay(ICON_REPLAY); });
    }
    function run(fromCanvas) {
      if (!painter) return; clear(); running = true; setPlay(ICON_REPLAY); count(0); painter.showNone();
      if (fromCanvas) { state('canvas'); timers.push(setTimeout(paintNow, reduce ? 0 : 700)); return; }
      state('photo');
      timers.push(setTimeout(function () {
        stg.classList.add('mapping'); state('canvas');
        timers.push(setTimeout(function () { stg.classList.remove('mapping'); timers.push(setTimeout(paintNow, reduce ? 0 : 500)); }, reduce ? 0 : 1300));
      }, reduce ? 0 : 1200));
    }
    function finish() { clear(); count(K); state('paint'); setPlay(ICON_REPLAY); }
    function ensure() { return built ? painter.ready : build(); }
    plays.forEach(function (b) { b.addEventListener('click', function () { ensure().then(function () { run(false); }); }); });
    det.forEach(function (b) { b.addEventListener('click', function () { var k = +b.getAttribute('data-k'); if (k === K && built && !running) { run(true); return; } clear(); K = k; build().then(function () { run(true); }); }); });
    exbs.forEach(function (b) { b.addEventListener('click', function () { clear(); key = b.getAttribute('data-k'); build().then(function () { run(false); }); }); });
    document.addEventListener('visibilitychange', function () { if (document.hidden && running) finish(); });
    if (!('IntersectionObserver' in window)) { build().then(finish); return; }
    /* 1) start loading when the section is near; 2) play once when 40% of the picture is on screen */
    var near = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      near.disconnect();
      build().then(function () {
        if (reduce) { finish(); return; }
        state('photo');
        var io = new IntersectionObserver(function (es2) { es2.forEach(function (e) {
          if (e.isIntersecting && !seen) { seen = true; run(false); }
          if (!e.isIntersecting && running) finish();
        }); }, { threshold: .4 });
        io.observe(stg);
      });
    }, { rootMargin: '600px 0px' });
    near.observe(root);
  }
  function boot() { document.querySelectorAll('.pkcps').forEach(init); }
  window.PKCPS = { boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
